import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://tinder-date.herokuapp.com/',
});

export default instance;